<template>
    <div class="loader-wrapper" :style="style">
        <div class="loader">
            <div class="progress-circle-indeterminate"></div>
        </div>
    </div>
</template>

<script type="text/babel">
    export default {
        props: {
            minHeight: {
                type: String,
                required: false,
                default: '200px'
            }
        },

        computed: {
            style() {
                return 'min-height: ' + this.minHeight + ';'
            }
        }
    }
</script>

<style lang="scss" scoped>
    .loader-wrapper {
        position: relative;

        .loader {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(235, 235, 235, 0.5);

            .progress-circle-indeterminate {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                width: 30px;
                height: 30px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// client/components/ComponentLoader.vue